/**
 * Implementa o modelo de uma configuração de usuário para a tabela de configurações.
 */
 export default class UsuarioConfig {
    constructor() {
        this.id = 1,
        this.fotos = {
            dataDeVencimento: new Date()
        }
    }
}
